import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";
import { loaderService } from "../loaderService";

const url = GlobalConstants.urlApi;

const getNotificacionesPush = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/notificaciones/getNotificacionesPush`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getArbolTerritorial = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/notificaciones/getArbolTerritorial`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const deleteNotificacionPush = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/notificaciones/deleteNotificacionPush`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveNotificacion = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/notificaciones/saveNotificacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateNotificacion = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/notificaciones/updateNotificacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const sendNotificationToUser = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/notificaciones/sendNotificationToUser`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const sendNotificationToTopic = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/notificaciones/sendNotificationToTopic`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const sendNotificationToSegmentacion = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/notificaciones/sendNotificationToSegmentacion`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveImagen = ({file, idNoti, nombreImg, extension}) => {
    const formData = new FormData();

    formData.append('id', idNoti.toString());
    formData.append('extension', extension);
    formData.append('nombreImg', nombreImg);
    formData.append('img', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/notificaciones/saveImagen`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const notificacionesService = {
    getNotificacionesPush,
    getArbolTerritorial,
    deleteNotificacionPush,
    saveNotificacion,
    updateNotificacion,
    sendNotificationToUser,
    sendNotificationToTopic,
    sendNotificationToSegmentacion, 
    saveImagen
};